import type { ConsentViewT } from "@/types/database/consents";

/** Prefer the live `consents_view` query, keep embedded diary rows until that loads. */
export function mergeDiaryConsents(
    embedded: ConsentViewT[] | null | undefined,
    queried: ConsentViewT[] | null | undefined
): ConsentViewT[] {
    const embeddedRows = embedded ?? [];
    const queriedRows = queried ?? [];
    if (queriedRows.length === 0) return embeddedRows;
    if (embeddedRows.length === 0) return queriedRows;

    const merged = new Map<string, ConsentViewT>();
    for (const consent of embeddedRows) {
        if (consent.consent_id) merged.set(consent.consent_id, consent);
    }
    for (const consent of queriedRows) {
        if (consent.consent_id) merged.set(consent.consent_id, consent);
    }
    return [...merged.values()];
}
